import { render, staticRenderFns } from "./myRedEnvelope.vue?vue&type=template&id=6f250942&scoped=true"
import script from "./myRedEnvelope.vue?vue&type=script&lang=js"
export * from "./myRedEnvelope.vue?vue&type=script&lang=js"
import style0 from "./myRedEnvelope.vue?vue&type=style&index=0&id=6f250942&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f250942",
  null
  
)

export default component.exports